import session from './session'

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]'])

function singleQueryValue(value) {
  return Array.isArray(value) ? null : value
}

export function isSafeReturnUrl(value) {
  if (!value || typeof value !== 'string') return false

  try {
    const url = new URL(value)
    if (url.username || url.password) return false

    return url.protocol === 'https:' ||
      (url.protocol === 'http:' && LOCAL_HOSTS.has(url.hostname))
  } catch {
    return false
  }
}

export function captureAuthContext(query) {
  const cafeId = singleQueryValue(query.cafe_id)
  const country = singleQueryValue(query.country)
  const redirectUri = singleQueryValue(query.redirect_uri)

  if (typeof cafeId === 'string' && /^\d+$/.test(cafeId)) session.set('cafe_id', cafeId)
  else session.remove('cafe_id')

  if (country === 'AU' || country === 'NZ') session.set('cafe_country', country)
  else session.remove('cafe_country')

  if (isSafeReturnUrl(redirectUri)) session.set('redirect_uri', redirectUri)
  else session.remove('redirect_uri')

  return getAuthContext()
}

export function getAuthContext() {
  return {
    cafeId: session.get('cafe_id'),
    country: session.get('cafe_country') || 'NZ',
    redirectUri: session.get('redirect_uri')
  }
}

export function buildReturnUrl(redirectUri, values) {
  if (!isSafeReturnUrl(redirectUri)) {
    throw new Error('The return address is not valid.')
  }

  const url = new URL(redirectUri)
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== null) url.searchParams.set(key, String(value))
  })
  return url.toString()
}
